import { render } from "./Callback_saml.vue?vue&type=template&id=59a89dd6"
import script from "./Callback_saml.vue?vue&type=script&lang=js"
export * from "./Callback_saml.vue?vue&type=script&lang=js"
script.render = render

export default script